import {
  Box,
  Container,
  Divider,
  Grid,
  ListSubheader,
  MenuItem,
  Typography,
} from '@material-ui/core'
import { Controller } from 'react-hook-form'
import { Navigate, useNavigate } from 'react-router-dom'

import Button from '@/components/button'
import InputText from '@/components/input-text'
import {
  DefaultPlantingFailureFormData,
  usePlantingFailureForm,
} from '@/pages/demands/steps/planting-failure-info/hooks/use-planting-failure-form'
import { routes } from '@/routes/config'

import { useDiagnosisRegistrationStore } from '../../contexts/diagnosis-registration-store-context'
import { useStyles } from './styles'

export const PlantingFailureInfo = () => {
  const classes = useStyles()
  const navigate = useNavigate()

  const { registerData, plantingFailureData, setPlantingFailureData } =
    useDiagnosisRegistrationStore((state) => ({
      registerData: state.registerData,
      plantingFailureData: state.plantingFailureData,
      setPlantingFailureData: state.setPlantingFailureData,
    }))

  const { control, handleSubmit } = usePlantingFailureForm({
    defaultValues: plantingFailureData || undefined,
  })

  async function onSubmit(data: DefaultPlantingFailureFormData) {
    setPlantingFailureData(data)
    navigate(routes.Demands('select-files'))
  }

  if (!registerData) return <Navigate to={routes.Demands('register')} replace />

  return (
    <Container
      className={classes.main}
      component='form'
      onSubmit={handleSubmit(onSubmit)}
    >
      <Box>
        <Box>
          <Typography variant={'h1'}>Novo Diagnóstico</Typography>
          <Typography variant={'h4'}>Informações básicas</Typography>
          <Grid container spacing={1} className={classes.container}>
            <Grid item xs={12}>
              <Controller
                name='planting_type'
                control={control}
                defaultValue={'convencional' as any}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => (
                  <InputText
                    select
                    SelectProps={{
                      MenuProps: {
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                        classes: { list: classes.menuList },
                      },
                    }}
                    id='planting_type'
                    value={value}
                    onChange={(e) => {
                      onChange(e.target.value)
                    }}
                    label={'Selecione o tipo de plantio'}
                    error={!!error}
                    helperText={error?.message}
                  >
                    <ListSubheader>Tipo de plantio</ListSubheader>
                    <MenuItem value={'convencional'}>Convencional</MenuItem>
                    <MenuItem value={'duplo_alternado'}>
                      Duplo Alternado
                    </MenuItem>
                    <MenuItem value={'meiosi'}>Meiosi</MenuItem>
                  </InputText>
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name='planting_space'
                control={control}
                defaultValue={50}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => (
                  <InputText
                    id='planting_space'
                    type='number'
                    value={value}
                    onChange={(e) => {
                      onChange(+e.target.value)
                    }}
                    label={'Espaçamento entre plantas (cm)'}
                    error={!!error}
                    helperText={error?.message}
                  ></InputText>
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name='cane_cycle_type'
                control={control}
                defaultValue={'nao_especificado' as any}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => (
                  <InputText
                    select
                    SelectProps={{
                      MenuProps: {
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                        classes: { list: classes.menuList },
                      },
                    }}
                    id='cane_cycle_type'
                    value={value}
                    onChange={(e) => {
                      onChange(e.target.value)
                    }}
                    label={'Selecione o tipo de ciclo'}
                    error={!!error}
                    helperText={error?.message}
                  >
                    <ListSubheader>Tipo de ciclo</ListSubheader>
                    <MenuItem value={'nao_especificado'}>
                      Não Especificado
                    </MenuItem>
                    <MenuItem value={'cana_planta'}>Cana Planta</MenuItem>
                    <MenuItem value={'cana_soca'}>Cana Soca</MenuItem>
                  </InputText>
                )}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Divider />
      <Box className={classes.buttonContainer}>
        <Button outlined onClick={() => navigate(-1)}>
          Cancelar
        </Button>
        <Button type='submit'>Avançar</Button>
      </Box>
    </Container>
  )
}
